import { BILLING, PAYOUT_METHODS } from 'ha/constants/pageNames';
import { showWeWantToPay } from './showWeWantToPay';

const shouldDisplayModal = (state, pageName) =>
  pageName !== BILLING && pageName !== PAYOUT_METHODS && showWeWantToPay(state);

export { shouldDisplayModal };
